import styles from './loading-check.module.scss';

type Props = {
  started?: boolean;
  progressDuration?: number;
  onComplete?: () => void;
};

const LoadingCheck = ({ started = false }: Props) => (
  <div className={styles.progressContainer} role="progressbar">
    <svg
      className={styles.progress}
      viewBox="-10 -12 32 32"
      xmlns="http://www.w3.org/2000/svg">
      {started && (
        <path
          d="M1.29522 5.6054C1.12331 5.44236 0.851781 5.44954 0.688735 5.62145C0.525689 5.79335 0.532873 6.06489 0.70478 6.22793L1.29522 5.6054ZM4.51449 9.25L4.21927 9.56126C4.30431 9.64192 4.41863 9.68427 4.53569 9.67848C4.65274 9.67269 4.76233 9.61926 4.83899 9.53061L4.51449 9.25ZM11.3245 2.03061C11.4795 1.85139 11.4598 1.58047 11.2806 1.4255C11.1014 1.27052 10.8305 1.29018 10.6755 1.46939L11.3245 2.03061ZM0.70478 6.22793L4.21927 9.56126L4.80971 8.93874L1.29522 5.6054L0.70478 6.22793ZM4.83899 9.53061L11.3245 2.03061L10.6755 1.46939L4.18999 8.96939L4.83899 9.53061Z"
          fill="#A6A1C5"
        />
      )}

      {!started && (
        <svg
          id="enBXAMuiL9K1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32">
          <ellipse
            rx="4.2"
            ry="4.2"
            transform="translate(6 6)"
            fill="#a6a1c5"
          />
          <g id="enBXAMuiL9K3_to" transform="translate(7.6,16)">
            <ellipse rx="4.2" ry="4.2" fill="#181926" />
            <animateTransform
              id="first"
              attributeName="transform"
              attributeType="XML"
              type="translate"
              begin="0s;second.end"
              dur="1.5s"
              from="2 6"
              to="10 6"
            />
            <animateTransform
              id="second"
              attributeName="transform"
              attributeType="XML"
              type="translate"
              begin="first.end"
              dur="1.5s"
              from="10 6"
              to="2 6"
            />
          </g>
        </svg>
      )}
    </svg>
  </div>
);

export default LoadingCheck;
